import { makeService } from './api';

const service = makeService('topics', null);

export default service;